import viVN from 'antd/lib/locale/vi_VN';

import auth from './auth';
import collection from './collection';
import common from './common';
import customer from './customer';
import dashboard from './dashboard';
import device from './device';
import events from './events';
import Form from './form';
import gift from './gift';
import gifts from './gifts';
import item from './item';
import pageError from './pageError';
import rankings from './rankings';
import report from './report';
import roles from './roles';
import server from './server';
import settings from './settings';
import user from './user';
import voucher from './voucher';

export default {
  ...viVN,
  ...common,
  ...server,
  ...auth,
  ...pageError,
  ...roles,
  ...user,
  ...settings,
  ...device,
  ...customer,
  ...gifts,
  ...voucher,
  ...item,
  ...gift,
  ...rankings,
  ...collection,
  ...events,
  ...dashboard,
  ...report,
  Form,
};
